const RTL_LANGUAGES = ['ar', 'fa', 'he', 'ur'];

/**
 * Angular's localized builds emit `dir="rtl"` on <html> for RTL locales, in both
 * `ng serve --configuration=ar-EG` and the production bundles. AppComponent then
 * overwrites it with "ltr" during ngOnInit, so the value is snapshotted here at
 * module-evaluation time - which always runs before bootstrapApplication.
 */
const initialDocumentDirection: string | null =
  typeof document === 'undefined'
    ? null
    : document.documentElement.getAttribute('dir');

function localizeLocale(): string | null {
  return (globalThis as { $localize?: { locale?: string } }).$localize?.locale ?? null;
}

function isRtlLocale(locale: string | null | undefined): boolean {
  const language = (locale ?? '').toLowerCase().split('-')[0];

  return RTL_LANGUAGES.includes(language);
}

/**
 * The locale actually in effect. This app bootstraps with bootstrapApplication and
 * never provides LOCALE_ID, so LOCALE_ID is "en-US" in every localized bundle and
 * cannot be relied on by itself. `$localize.locale` is correct in production
 * builds; the dev server only carries the direction, where Arabic is the sole RTL
 * locale this app ships.
 */
export function resolveActiveLocale(localeId?: string | null): string {
  const fromLocalize = localizeLocale();
  if (fromLocalize) {
    return fromLocalize;
  }

  if (localeId && localeId !== 'en-US') {
    return localeId;
  }

  if (initialDocumentDirection === 'rtl') {
    return 'ar-EG';
  }

  return localeId || 'en-US';
}

export function directionForLocale(localeId?: string | null): 'rtl' | 'ltr' {
  return isRtlLocale(resolveActiveLocale(localeId)) ? 'rtl' : 'ltr';
}
